module.exports = __webpack_public_path__ + "img/img001.185bfc91.png";